define("shared/utils/filter-list", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  const filterList = [{
    displayName: 'Harrison',
    type: 'LaterClarendon',
    class: 'filter-harrison',
    create: filters => new filters.LaterClarendon()
  }, {
    displayName: 'Seymour',
    type: 'LaterGingham',
    class: 'filter-seymour',
    create: filters => new filters.LaterGingham()
  }, {
    displayName: 'Kain',
    type: 'LaterMoon',
    class: 'filter-kain',
    create: filters => new filters.LaterMoon()
  }, {
    displayName: 'Lynn',
    type: 'LaterLark',
    class: 'filter-lynn',
    create: filters => new filters.LaterLark()
  }, {
    displayName: 'Old Settler',
    type: 'LaterReyes',
    class: 'filter-oldsettler',
    create: filters => new filters.LaterReyes()
  }, {
    displayName: 'Burnaby',
    type: 'LaterJuno',
    class: 'filter-burnaby',
    create: filters => new filters.LaterJuno()
  }, {
    displayName: 'Needles',
    type: 'LaterSlumber',
    class: 'filter-needles',
    create: filters => new filters.LaterSlumber()
  }, {
    displayName: 'Hollyburn',
    type: 'LaterCrema',
    class: 'filter-hollyburn',
    create: filters => new filters.LaterCrema()
  }, {
    displayName: 'Elsay',
    type: 'LaterLudwig',
    class: 'filter-elsay',
    create: filters => new filters.LaterLudwig()
  }, {
    displayName: 'Raleigh',
    type: 'LaterAden',
    class: 'filter-raleigh',
    create: filters => new filters.LaterAden()
  }, {
    displayName: 'Anaheim',
    type: 'LaterPerpetua',
    class: 'filter-anaheim',
    create: filters => new filters.LaterPerpetua()
  }, {
    displayName: 'Crown',
    type: 'LaterAmaro',
    class: 'filter-crown',
    create: filters => new filters.LaterAmaro()
  }, {
    displayName: 'Lucky Four',
    type: 'LaterMayfair',
    class: 'filter-luckyfour',
    create: filters => new filters.LaterMayfair()
  }, {
    displayName: 'Hanover',
    type: 'LaterRise',
    class: 'filter-hanover',
    create: filters => new filters.LaterRise()
  }, {
    displayName: 'Nicomen',
    type: 'LaterHudson',
    class: 'filter-nicomen',
    create: filters => new filters.LaterHudson()
  }, {
    displayName: 'Lions',
    type: 'LaterValencia',
    class: 'filter-lions',
    create: filters => new filters.LaterValencia()
  }, {
    displayName: 'Sumas',
    type: 'LaterXProII',
    class: 'filter-sumas',
    create: filters => new filters.LaterXProII()
  }, {
    displayName: 'Grouse',
    type: 'LaterSierra',
    class: 'filter-grouse',
    create: filters => new filters.LaterSierra()
  }, {
    displayName: 'Ernest',
    type: 'LaterWillow',
    class: 'filter-ernest',
    create: filters => new filters.LaterWillow()
  }, {
    displayName: 'Robie',
    type: 'LaterLofi',
    class: 'filter-robie',
    create: filters => new filters.LaterLofi()
  }, {
    displayName: 'Abbott',
    type: 'LaterInkwell',
    class: 'filter-abbott',
    create: filters => new filters.LaterInkwell()
  }, {
    displayName: 'Chilliwack',
    type: 'LaterHefe',
    class: 'filter-chilliwack',
    create: filters => new filters.LaterHefe()
  }, {
    displayName: 'Fay',
    type: 'LaterNashville',
    class: 'filter-fay',
    create: filters => new filters.LaterNashville()
  }];
  var _default = filterList;
  _exports.default = _default;
});